"use strict";

define('rs/components/select',['vertebrae'], function (Vertebrae) {
  var SelectView = Vertebrae.View.extend({
    tagName: 'select',
    events: {
      'change': 'selectedItemDidChange'
    },
    render: function render(options) {
      var $el = this.$el;
      if (options instanceof Backbone.Collection) {
        if (this._collection) {
          this.stopListening(this._collection);
        }
        this._collection = options;
        var render = _.bind(this.render, this);
        this.listenTo(options, 'add remove reset change', _.debounce(function () {
          render(options.toJSON());
        }, 20));
        return this.render(options.toJSON());
      }
      $el.empty();
      for (var i = 0, len = options.length, option; i < len; i++) {
        option = options[i];
        $el.append($('<option/>').attr('data-index', i).val(option.value).text(option.text).prop('selected', !!option.selected));
      }
      this._currentIndex = this.$el.prop('selectedIndex');
      return this;
    },
    selectedItemDidChange: function selectedItemDidChange(ev) {
      var propIndex = this.$el.prop('selectedIndex'),
        index = this.$('option').eq(propIndex).data('index'),
        collection = this._collection;
      if (collection && collection.at(index)) {
        if (this._currentIndex >= 0 && collection.at(this._currentIndex)) {
          collection.at(this._currentIndex).set({
            selected: true
          });
        }
        collection.at(index).set('selected', true);
      }
      this._currentIndex = index;
      this.trigger('select', index);
      return true;
    }
  });
  return SelectView;
});

